var React = require('react');

function Quotes (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.23,17H0L5.03,0h5.51L6.23,17Z","style":{"fill":"#00ffa8"},"key":0}),React.createElement("path",{"d":"M17.96,17h-6.23L16.76,0h5.51l-4.31,17Z","style":{"fill":"#00ffa8"},"key":1})]);
}

Quotes.defaultProps = {"id":"uuid-0c3344e7-e4d0-4e78-be16-60d9ac1984d9","viewBox":"0 0 22.27 17"};

module.exports = Quotes;

Quotes.default = Quotes;
